import { render } from "./ReporteriaPresupuestos.vue?vue&type=template&id=b670da22"
import script from "./ReporteriaPresupuestos.vue?vue&type=script&lang=js"
export * from "./ReporteriaPresupuestos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__